module.exports = __webpack_public_path__ + "static/media/ic_concentrator.0a994c99.svg";